import { breakpoints } from '@/config/breakpoints';
import { styled } from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
  padding: 0px 24px;
  max-width: 1176px;
  margin: 0 auto;
  p,
  span {
    text-align: center;
  }
  @media screen and (max-width: ${breakpoints.lg}) {
    padding: 0 16px;
  }
`;

export const ListWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;
  @media screen and (max-width: ${breakpoints.lg}) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media screen and (max-width: ${breakpoints.md}) {
    grid-template-columns: repeat(1, 1fr);
  }
`;

export const CardWrapper = styled.div`
  position: relative;

  min-height: 252px;
  overflow: hidden;
  border-radius: 12px;
  background: var(--bg-on-blue, #141420);
  box-shadow: 0px 22px 17px 0px rgba(0, 0, 0, 0.02),
    0px 13px 10px 0px rgba(0, 0, 0, 0.02), 0px 7px 5px 0px rgba(0, 0, 0, 0.02),
    0px 3px 2px 0px rgba(0, 0, 0, 0.04), 0px 0px 0px 1px rgba(53, 72, 91, 0.14);
`;

export const GradientBg = styled.div`
  transition: opacity 0.3s ease;
  background: linear-gradient(
    180deg,
    rgba(70, 14, 96, 0.06) 0%,
    rgba(159, 84, 255, 0) 39.86%,
    rgba(159, 84, 255, 0.5) 100%
  );
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 1;
`;

export const BodyCard = styled.div`
  position: relative;
  z-index: 2;
  padding: 24px 17px 24px 24px;
  display: flex;
  flex-direction: column;
  /* justify-content: space-between; */
  height: 100%;
  /* transition: opacity 0.3s ease;
  background: linear-gradient(
    180deg,
    rgba(70, 14, 96, 0.06) 0%,
    rgba(159, 84, 255, 0) 39.86%,
    rgba(159, 84, 255, 0.5) 100%
  );
  opacity: 0;
  &:hover {
    opacity: 1;
  } */
`;

export const IconWrapper = styled.div`
  img {
    transform-origin: bottom left;
    transition: 0.3s ease;
  }
`;
export const CardContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  transition: 0.3s ease;
  p {
    margin: 0px;
  }
`;

export const CardTitle = styled.p`
  color: var(--text-primary, #fff);
  font-family: 'GTWalsheimPro';
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px; /* 133.333% */
  text-align: start !important;
`;

export const CardDescription = styled.p`
  color: var(--text-secondary, #d2d2d2);
  font-family: 'GTWalsheimPro';
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 150% */
  text-align: start !important;
`;
